import { render, staticRenderFns } from "./CustomTabs.vue?vue&type=template&id=7a1ec68c&scoped=true"
import script from "./CustomTabs.vue?vue&type=script&lang=js"
export * from "./CustomTabs.vue?vue&type=script&lang=js"
import style0 from "./CustomTabs.vue?vue&type=style&index=0&id=7a1ec68c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ec68c",
  null
  
)

export default component.exports